'use client';

import React from 'react';
import RecentlyViewedList from './RecentlyViewedList';
import RecentlyViewedListSkeleton from './RecentlyViewedListSkeleton';
import SectionContainer from '@/components/shared/SectionContainer';
import { QueryBoundary } from '@/components/ui/QueryBoundary';
import SectionHeader from '../../components/SectionHeader';
import { Flex } from '@skin-seoul/design-system';
import type { Product } from '@skin-seoul/service';
type RecentlyViewedSectionProps = {
  recentlyViewedProducts: Product[];
};
const RecentlyViewedSection = ({
  recentlyViewedProducts
}: RecentlyViewedSectionProps) => {
  return <SectionContainer containerWrapperProps={{
    backgroundColor: 'generic.0'
  }} data-sentry-element="SectionContainer" data-sentry-component="RecentlyViewedSection" data-sentry-source-file="RecentlyViewedSection.tsx">
      <Flex direction="column" width="100%" gap={6} data-sentry-element="Flex" data-sentry-source-file="RecentlyViewedSection.tsx">
        <SectionHeader title="Recently Viewed" data-sentry-element="SectionHeader" data-sentry-source-file="RecentlyViewedSection.tsx" />
        <QueryBoundary clientOnly loadingFallback={<RecentlyViewedListSkeleton length={4} />} data-sentry-element="QueryBoundary" data-sentry-source-file="RecentlyViewedSection.tsx">
          <RecentlyViewedList recentlyViewedProducts={recentlyViewedProducts} data-sentry-element="RecentlyViewedList" data-sentry-source-file="RecentlyViewedSection.tsx" />
        </QueryBoundary>
      </Flex>
    </SectionContainer>;
};
export default RecentlyViewedSection;